// ============================================
// ヘッダー
// ============================================

export default function initHeader() {
  setHeaderHeight();
  scrollHeaderFixed();
}

/**
 * ヘッダーの高さをCSS変数に設定する関数
 * 要素のリサイズを検知して再取得します。
 */
function setHeaderHeight(cssVariableName = "--header-height-gutter") {
  const header = document.querySelector(".js-header-fixed");
  if (!header) return;

  let headerH = header.clientHeight;
  document.documentElement.style.setProperty(cssVariableName, headerH + "px");

  // 要素のリサイズを監視して再取得
  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      // ヘッダーの高さを再設定
      headerH = entry.target.clientHeight;
      document.documentElement.style.setProperty(cssVariableName, headerH + "px");
    }
  });
  resizeObserver.observe(header);
}

/**
 * scrollでheader固定
 */
function scrollHeaderFixed() {
  const fixedHeader = document.querySelector(".js-header-fixed");

  if (!fixedHeader) return;

  function scrollHandler() {
    // 一定量スクロールしたらclass付与
    fixedHeader.classList.toggle("is-header-scroll", window.scrollY > 500);
  }

  window.addEventListener("scroll", scrollHandler);
  scrollHandler();
}
